/* eslint-disable jsx-a11y/label-has-associated-control */
import { useContext } from 'react';
import { isLeadASubBooking } from 'utils/lead/leadUtils';
import LeadModalContext from '../../../LeadModalContext';
import { GuestInformationContainer } from '../LeadModalStayDetailsTab.styles';
import MainGuest from './sections/MainGuest';
import ExtraGuests from './sections/ExtraGuests';
import ExtraInformation from './sections/ExtraInformation';

const GuestInformation = () => {
  const { lead } = useContext(LeadModalContext);

  if (!lead || isLeadASubBooking(lead)) {
    return null;
  }

  return (
    <GuestInformationContainer className="pre-arrival-guest-information">
      <MainGuest />

      <ExtraGuests />

      <ExtraInformation />
    </GuestInformationContainer>
  );
};

export default GuestInformation;
